// The Studio bundle's build stamp. vite.config.js defines both globals from
// VITE_BUILD_SHA / VITE_BUILD_TIME, which the Studio image build sets from
// Cloud Build (apps/studio/Dockerfile); a dev server or local build leaves
// them empty. The typeof guards keep this module loadable without the define.
export const STUDIO_BUILD = Object.freeze({
  sha: typeof __STUDIO_BUILD_SHA__ === 'string' ? __STUDIO_BUILD_SHA__ : '',
  time: typeof __STUDIO_BUILD_TIME__ === 'string' ? __STUDIO_BUILD_TIME__ : '',
})

export function shortSha(sha) {
  return String(sha || '').slice(0, 8)
}

// YYYY-MM-DD in UTC, or '' when the value is not a parseable time.
export function utcDay(time) {
  if (!time) return ''
  const parsed = new Date(time)
  return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString().slice(0, 10)
}

export function describeStudioBuild(build = STUDIO_BUILD) {
  const sha = shortSha(build?.sha)
  const day = utcDay(build?.time)
  if (!sha && !day) return 'Studio build (unstamped)'
  if (!day) return `Studio build ${sha}`
  if (!sha) return `Studio build (${day})`
  return `Studio build ${sha} (${day})`
}
